export { default } from './AlertText';
export type { Variant } from './AlertText';
